/* Every dimension in millimetres. This file is the single source of truth for
   the card's physical layout — change a number here and both the on-screen
   preview and the exported PDF move together. Nothing else hardcodes geometry.

   Panel widths come from the Ultra Ferric Canva artboard (4.0625 x 4 in):
   1 in flap + 0.5 in spine + 2.5625 in cover = 4.0625 in exactly. */

window.JCARD = window.JCARD || {};

JCARD.geom = (function () {
  const CARD_H = 101.6;
  const FLAP_W = 25.4;
  const SPINE_W = 12.7;
  const COVER_W = 65.09;
  const CARD_W = FLAP_W + SPINE_W + COVER_W;

  // Panel origins on page 1 (outside): flap | spine | cover, left to right.
  const OUT = {
    flapX: 0,
    spineX: FLAP_W,
    coverX: FLAP_W + SPINE_W,
  };

  // Page 2 (inside) reverses the order so the panels register through the
  // sheet after a duplex flip: tracklist | spine | flap.
  const IN = {
    tracksX: 0,
    spineX: COVER_W,
    flapX: COVER_W + SPINE_W,
  };

  return {
    CARD_W, CARD_H, FLAP_W, SPINE_W, COVER_W, OUT, IN,

    // Fold lines, measured from the left edge of each page.
    foldsOutside: [FLAP_W, FLAP_W + SPINE_W],
    foldsInside: [COVER_W, COVER_W + SPINE_W],

    outside: {
      // Rotated text on the wrap flap. x is the baseline the glyphs sit on.
      flapLabel: { x: 19.8, y: CARD_H / 2, anchor: 'middle' },
      attribution: { x: 15.4, y: CARD_H - 8, anchor: 'end' },

      // Spine: a short bar at each end, rotated text between them.
      spineBar: { w: 8.5, h: 0.72, topY: 10.7, bottomY: CARD_H - 11.42 },
      // x is where the ink should be centred, not where the baseline goes; the
      // renderer works the baseline back from it using the type size.
      spineText: { x: OUT.spineX + SPINE_W / 2, y: CARD_H / 2, anchor: 'middle' },

      // Cover panel.
      coverMargin: 6.35,
      image: {
        x: OUT.coverX + 6.35,
        y: 10.16,
        w: COVER_W - 12.7,
        h: COVER_W - 12.7,
      },
      dividerRule: { x: OUT.coverX + 6.35, y: 65.05, w: COVER_W - 12.7, h: 0.72 },
      albumTitle: { x: OUT.coverX + 6.35, y: 71.6, size: 4.6, lineHeight: 1.1, maxLines: 2 },
      artistName: { x: OUT.coverX + 6.35, y: 77.6, size: 3.3 },
      formatLine: { x: OUT.coverX + 6.35, y: 82.8, size: 2.0, tracking: 0.09 },

      // Where the title block sits when the image covers the whole panel.
      overlayTitleY: CARD_H - 26.0,
      overlayArtistY: CARD_H - 20.0,
      overlayFormatY: CARD_H - 14.8,
      overlayRuleY: CARD_H - 31.4,

      /* Two limits per text area, because a block of text can overrun on
         either axis. `run` is the length along the baseline. `cross` is the
         depth the stack of lines is allowed to occupy at right angles to it —
         without that, only the first line is held inside the panel and the
         rest walk off the card. */
      textWidths: {
        cover: COVER_W - 12.7,
        spine: 76.0,          // clear of the two end bars
        flap: 85.0,
        spineCross: SPINE_W - 1.6,
        flapCross: FLAP_W - 1.6,
      },
      bottomMargin: 3.0,
    },

    inside: {
      blocks: [
        { side: 'A', top: 10.7, bottom: 52.8 },
        { side: 'B', top: 55.0, bottom: 96.8 },
      ],
      blockDivider: { x1: 7.6, x2: 61.5, y: 53.9 },

      // Twelve write-on rules per block. The DATE/TIME and NOISE REDUCTION
      // labels from the original template are gone, so the columns run wider.
      columns: { count: 12, left: 8.0, right: 50.0 },
      // Track text sits just clear of its rule; with the 90-degree rotation the
      // glyphs stand off to the right of the line, i.e. on top of it when read.
      trackText: { size: 1.9, offset: 0.3 },

      sideBar: { x: 52.3, w: 0.8 },
      badge: { cx: 59.5, r: 2.6, dy: 3.4, size: 3.0 },

      spineText: { x: IN.spineX + SPINE_W / 2, y: CARD_H / 2, anchor: 'middle' },
      credits: { x: IN.flapX + 14.4, y: CARD_H / 2, anchor: 'middle' },
      attribution: { x: IN.flapX + 9.9, y: CARD_H - 8, anchor: 'end' },

      textWidths: {
        spine: 85.0,
        flap: 85.0,
        spineCross: SPINE_W - 1.6,
        flapCross: FLAP_W - 1.6,
      },
      lineHeight: 1.15,
    },

    // A4 sheet used for export. The card is centred; crop marks sit outside it.
    sheet: { w: 210, h: 297 },
    cropMark: { len: 4, gap: 2, weight: 0.2 },
  };
})();
